$(document).ready(function() {
	if(!document.querySelector('.GPC0101')) return false;

	/*
	if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_ANALYSIS_OF_SITE')) {
	} else {
		var $obj=$('.GPC0101');
		$obj.find('a[data-link-name=live_chat]').off().on('click', function(e) {
			e.preventDefault();
			ePrivacyCookies.view('click');
		});
	}
	*/

	/* LGEBR-359 Start */
	var countryCode = $('html').data('countrycode').toUpperCase();
	if(countryCode == 'BR'){
		$('.GPC0101').each(function(){
			var unitBox = $(this).find('.unit-box'),
				imgBox = $(this).find('.unit-box-icon.img-box'),
				columnIdx = parseInt(unitBox.length),
				imgAlone = parseInt(imgBox.length),
				mainColumnIdx = columnIdx - imgAlone;

			if(imgAlone && !ISMAIN){
				imgBox.closest('.unit-box').remove();
				$(this).addClass('column-' + mainColumnIdx).removeClass('column-' + columnIdx);
			}
		});
	}
	/* LGEBR-359 End */

	/* LGECN-214 Start */
	if(lgCggroupName == 'home' && COUNTRY_CODE.toLowerCase() == 'cn' && typeof _hmt != 'undefined'){
		$('.GPC0101').on('click', ' a', function(){
			var $clickContent = $(this).find('.unit-box-head h2').text();
			console.log('[Baidu trackEvent] [Homepage_Service & Support] ', ', $lg_cggroup : '+ $lg_cggroup, ', $clickContent : '+$clickContent);
			_hmt.push(['_trackEvent',$lg_cggroup,'Click '+$clickContent,'Homepage_Service & Support']);
		});	
	}
	/* LGECN-214 Start */
});